import { render, staticRenderFns } from "./PreliveView.vue?vue&type=template&id=247b7d97&scoped=true"
import script from "./PreliveView.vue?vue&type=script&lang=js"
export * from "./PreliveView.vue?vue&type=script&lang=js"
import style0 from "./PreliveView.vue?vue&type=style&index=0&id=247b7d97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b7d97",
  null
  
)

export default component.exports